// import * as a from '../../actions/action_types'
import {
    POST_LOAD_URL, POST_INVENTORY_URL,
    CREATED_NEEDS,
    CREATED_INVENTORY,
    BID_NEEDS,
    BIDS_INVENTORY,
    PT_PLUS_PAGE,
    REQUESTED_ID,
    SEARCH_POST,
    SEARCH_INVENTORY,
    ORDERS,
    MYCOMMUNITY,
    FAQ,
    MANAGE_ACCOUNT,
    NOTIFICATION,
    DETAILS,
    CHECKOUT,
    RESOLUTION_CENTER,
    BIDS_PAGINATION,
    NEARBY_PAGINATION,
    MYORDER_PAGINATION
} from '../../actions/action_types';

const INTIAL_STATE = {
    urlObject: '',
}

export default (state = INTIAL_STATE, action) => {
    if (state === undefined) {
        state = null;
    }
    if (state === undefined) {
        state = null;
    }
    switch (action.type) {
        case POST_LOAD_URL: {
            return { ...state, payload: action.payload }
        }
        case POST_INVENTORY_URL: {
            return { ...state, inventoryPayload: action.payload }
        }
        case CREATED_NEEDS: {
            return { ...state, createdNeeds: action.payload }
        }
        case CREATED_INVENTORY: {
            
            return { ...state, createdInventory: action.payload }
        }
        case BIDS_INVENTORY: {
            
            return { ...state, bidsInventory: action.payload }
        }
        case REQUESTED_ID: {
            
            return { ...state, requestedId: action.payload }
        }
        case BID_NEEDS: {
            
            return { ...state, bidNeeds: action.payload }
        }
        case PT_PLUS_PAGE: {
            
            return { ...state, ptPlusPage: action.payload }
        }
        case SEARCH_POST: {
            
            return { ...state, searchPostNeed: action.payload }
        }
        case SEARCH_INVENTORY: {
            
            return { ...state, searchPostInventory: action.payload }
        }
        case ORDERS: {
            
            return { ...state, orders: action.payload }
        }
        case MYCOMMUNITY: {
            
            return { ...state, community: action.payload }
        }
        case FAQ: {
            
            return { ...state, faq: action.payload }
        }
        case MANAGE_ACCOUNT: {
            
            return { ...state, manageAccount: action.payload }
        }
        case NOTIFICATION: {
            
            return { ...state, notification: action.payload }
        }
        case DETAILS: {
            
            return { ...state, details: action.payload }
        }
        case CHECKOUT: {
            
            return { ...state, checkout: action.payload }
        }
        case RESOLUTION_CENTER: {
            
            return { ...state, resolution: action.payload }
        }
        case BIDS_PAGINATION: {
            
            return { ...state, selectedPage: action.payload }
        }
        case NEARBY_PAGINATION: {
            
            return { ...state, nearBySelectedPage: action.payload }
        }
        case MYORDER_PAGINATION: {
            
            return { ...state, myOrderSelectedPage: action.payload }
        }
        
        default:
            return state;
    }
}